var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicableAreaForm',{attrs:{"detail":_vm.detail,"update":false},on:{"saveDetail":_vm.saveDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }